import { render, staticRenderFns } from "./TeacherBalance.vue?vue&type=template&id=0651af22"
import script from "./TeacherBalance.vue?vue&type=script&lang=js"
export * from "./TeacherBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0651af22')) {
      api.createRecord('0651af22', component.options)
    } else {
      api.reload('0651af22', component.options)
    }
    module.hot.accept("./TeacherBalance.vue?vue&type=template&id=0651af22", function () {
      api.rerender('0651af22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/TeacherBalance.vue"
export default component.exports